import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Input,
  Modal,
  Select,
  Form,
  Popconfirm,
  message,
  Checkbox,
} from "antd";
import { useNavigate } from "react-router-dom";

import { Messages, Notify } from "../../services/custom/Messages";
import util from "../../../src/utils/functions/custom";
import service from "../../services/usersService";
import {openNotification} from "@seims/shared";
import { recordError } from "../../utils/logService";

const UserAddModal = (props) => {
  const formName = "Register";
  const [disabled, setDisabled] = useState(true);
  const [userRoles, setUserRoles] = useState([]);
  const [form] = Form.useForm();
  const { Option } = Select;
  const emailAddressRef = useRef(null);
  const navigate = useNavigate();
  let path = `/login`;
  const passwordRegEx = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
  const Passwordmessages = "Password must be at least 8 characters long, have 1 number,1 uppercase, and 1 special character";

  let msg = "";

  useEffect(() => {
    // getRoles();
  }, []);

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 12,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 12,
      },
      sm: {
        span: 14,
      },
    },
  };

  const Confirm = () => {
    form.resetFields();
    props.onCancel(false);
    setDisabled(true);
  };

  // const getRoles = async () => {
  //   const entity = "roles";
  //   try {
  //     setUserRoles([]);
  //     const response = await service.getRoles();
  //     if (response) {
  //       setUserRoles(response.data);
  //     }
  //   } catch (error) {
  //     msg = util.parseMessage(Messages.GET_FAILURE, entity);
  //     message.error(msg);
  //   }
  // };

  const handleCancel = () => {
    if (
      form.getFieldValue("emailAddress") ||
      form.getFieldValue("firstname") ||
      form.getFieldValue("lastname") ||
      form.getFieldValue("passwords") || form.getFieldValue("Password confirmation")
    ) {
      setDisabled(false);
    } else {
      form.resetFields();
      props.onCancel(false);
      setDisabled(true);
    }
  };

  // const checkEmailExistance = async () => {
  //   var emailValidity;
  //   try {
  //     emailValidity = await service.checkEmailExists(
  //       form.getFieldValue("emailAddress")
  //     );
  //     props.onShowRegister(true);
  //     console.log("Email validity", emailValidity);
  //     if (emailValidity.status == 204) {
  //       msg = util.parseMessage(Messages.USER_EXISTS, "Email");
  //       message.warning(msg);

  //       emailAddressRef.current.focus();
  //       return;
  //     }
  //   } catch (error) {
  //     if (error.response.status == 400) {
  //       msg = util.parseMessage(Messages.INVALID_EMAIL_DOMAIN, "Email");
  //       message.warning(msg);

  //       emailAddressRef.current.focus();
  //       return;
  //     }
  //     console.log("Checked email existence error", error);
  //   }
  // };

  const createUser = async (values) => {
  
    const entity = "User";
    const hide = message.loading("Submitting in progress, please wait...", 0);

    const acceptedTerms = props.acceptedTerms;

    const { firstname, lastname, emailAddress, password } = values;

    const publicUser = {
      userDetails: {
        firstname: firstname,
        lastname: lastname,
        password: password,
        emailAddress: emailAddress,
      },
      acceptedTerms: acceptedTerms,
    };

    let response;
    try {
      response = await service.addUser(publicUser, "nys-candidate");
    } catch (error) {
      response = error.response;
      
      recordError(error)

    }
    hide();
    var action = "NYS registration";
    if (response) {
      if (response.status == 409) {
        msg = util.parseMessage(Messages.PUBLIC_USER_EXISTS, "Email");
        openNotification(action, msg, Notify.ERROR);
        return;
      }

      props.onCancel(false);
      form.resetFields();
      msg = util.parseMessage(Messages.ADD_SUCCESS_ACCOUNT, entity);
      openNotification(action, msg, Notify.SUCCESS);
      // message.success(msg);
      navigate(path);
    } else {
      msg = util.parseMessage(Messages.ADD_FAILURE, entity);
      message.error(msg);
    }
  };

  return (
    <>
      <Modal
        title="NYS Registration"
        // visible={props.show}
        open={props.show}
        closable={false}
        keyboard={false}
        maskClosable={false}
        footer={[
          <div className="modal-footer-buttons">
            <Popconfirm
              title="Are you sure you want to cancel...you will lose all info entered?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => Confirm()}
              onCancel={handleCancel}
              disabled={disabled}
            >
              <Button
                onMouseUp={() => handleCancel()}
                style={{ marginLeft: 10 }}
              >
                Cancel
              </Button>
            </Popconfirm>
            <Button
              type="primary"
              htmlType="submit"
              onSubmit={createUser}
              form={formName}
            >
              Register
            </Button>
            
          </div>,
        ]}
      >
        <Form name={formName} form={form}  onFinish={createUser} {...formItemLayout}>
          <Form.Item
            name="firstname"
            label="First name"
            rules={[{ required: true, message: "Please enter your firstname" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="lastname"
            label="Last name"
            rules={[{ required: true, message: "Please enter your lastname" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="emailAddress"
            label="Email"
            // onBlur={checkEmailExistance}
            rules={[
              {
                type: "email",
                message: "The input is not valid E-mail",
              },
              {
                required: true,
                message: "Please enter your E-mail",
              },
            ]}
          >
            <Input ref={emailAddressRef} />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[
              {
                required: true,
                message: Passwordmessages,
                pattern: passwordRegEx
              },
            ]}
            hasFeedback
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            name="Password confirmation"
            label="Confirm Password"
            dependencies={["password"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: Passwordmessages,
                pattern:passwordRegEx
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error(
                      "The two passwords that you entered do not match!"
                    )
                  );
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default UserAddModal;
